<template>
  <Popover
    v-model="show"
    :target="popoverTarget"
    trigger="manual"
    placement="bottom"
    custom-class="saved-report-popover"
  >
    <btn
      v-if="label"
      ref="labelButton"
      v-tooltip.bottom.hover="tooltip"
      class="m-l-10"
      native-type="submit"
      size="sm"
      :type="type"
      :disabled="disabled"
      @click="onClick"
    >
      {{ label }}
    </btn>
    <i
      v-if="!label"
      ref="icon"
      v-tooltip.bottom.hover="tooltip"
      class="btn btn-function f-s-16 m-l-10"
      :class="iconClass"
      :type="type"
      :disabled="disabled"
      @click="onClick"
    />
    <template slot="popover">
      <div class="clearfix">
        <form>
          <div class="m-b-25">
            <label v-t="'VISIBILITY'" />
            <btn-group justified>
              <btn
                v-model="visibility"
                input-type="radio"
                input-value="personal"
                type="primary"
                justified
              >
                {{ $t('PERSONAL') }}
              </btn>
              <btn
                v-model="visibility"
                input-type="radio"
                input-value="shared"
                type="primary"
                justified
              >
                {{ $t('SHARED') }}
              </btn>
            </btn-group>
          </div>
        </form>
        <btn
          v-t="'CANCEL'"
          class="pull-left"
          type="default"
          size="sm"
          @click="show = false"
        />
        <btn
          v-t="'SAVE'"
          class="pull-right"
          type="primary"
          size="sm"
          :disabled="disabled"
          @click="$emit('onSaveReport', visibility === 'shared')"
        />
      </div>
    </template>
  </Popover>
</template>

<script>
import sharedMessages from '@/core/locales';
import messagesCommon from './locales-common';

export default {
  props: {
    label: {
      type: String,
      default: null
    },
    iconClass: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    updateOnly: {
      type: Boolean,
      required: false
    },
    tooltip: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'default'
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      visibility: 'personal',
      popoverTarget: null
    };
  },
  mounted() {
    this.popoverTarget = this.label ? this.$refs.labelButton : this.$refs.icon;
  },
  methods: {
    onClick: function() {
      if(this.updateOnly) {
        this.$emit('onSaveReport');
      } else {
        if (this.isAdmin) {
          this.show = !this.disabled;
        } else {
          this.$emit('onSaveReport', false);
        }
      }
    }
  },
  i18n: {
    locale: 'en',
    messages: messagesCommon,
    sharedMessages
  }, 
};
</script>

<style lang="scss">
.saved-report-popover {
  background-color: var(--component-in-app-notifications__popover);
  &.popover.bottom > .arrow:after {
    border-bottom-color: var(--component-in-app-notifications__popover);
  }
  .form-group {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>